module.exports = __webpack_public_path__ + "img/40_38_056_670.0bd0205b.jpg";